var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoubleCheck = function SvgDoubleCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 16,
    "data-width-24": 20,
    viewBox: "0 0 19.9 9.9",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.195 1.195a.7.7 0 0 0-.99-.99L5.2 8.21 1.195 4.205a.7.7 0 0 0-.99.99l4.5 4.5a.7.7 0 0 0 .99 0zm5.5 0a.7.7 0 0 0-.99-.99L10.7 8.21l-.505-.505a.7.7 0 0 0-.99.99l1 1a.7.7 0 0 0 .99 0z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleCheck);
export default ForwardRef;